module.exports = __webpack_public_path__ + "static/media/receiving-date-icon.6b6534e8.svg";